/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ExperienceImportIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Experience Import',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M6 14v-3.328a.5.5 0 0 1 .866-.341L14 18l-7.134 7.669A.5.5 0 0 1 6 25.328V22H1a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1Z"
    />
    <path
      d="M35 4H5a1 1 0 0 0-1 1v3h28v8H16v12H4v3a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm-3 24H18v-4h14Zm0-6H18v-4h14Z"
    />
  </svg>`;
};
